module.exports = __webpack_public_path__ + "static/media/monitor-heart-rate.ecadb193.svg";